/**
 * Strings found in application. Eventually this can be used to introduce i18n
 */

// file/headerView
export const filesConfirmRemovingFileText = (filename) =>
  `You are about to remove the data source: ${filename}`;

// etlFieldView
export const fieldConfirmDelete = (fieldName) =>
  `You are about to remove the field: ${fieldName}`;
